// extracted by mini-css-extract-plugin
export default {"mainFrame":"styles_mainFrame__ZaFOr","withHeader":"styles_withHeader__C5gVC"};